import React, { Component } from 'react';

import { Box } from '@mui/material';
import { OpenToast } from '../components/shared/StyledToast';

import authService from '../services/wss/AuthService';
import { subscribe } from '../services/utils/pubsub';
import { events } from '../services/wss/SystemEvents';
import { toast } from 'react-toastify';
import publisher from '../services/wss/SystemEventPublisher';
import logService from '../services/wss/logService3';
import messageFactory from '../services/wss/MessageFactory';
import systemStreamer from '../services/wss/SystemStreamer';

let _name = 'PageContent';
/**
 *
 *  initializes streamer for page refresh
 *
 */
class PageContent extends Component {
    componentDidMount = async () => {
        if (this.mounted) return;
        this.mounted = true;

        this.onDataReceived = subscribe(events.onSocketDataReceived, (p) => this.handleData(p));
        this.onReconnected = subscribe(events.onReconnected, (p) => this.handleReconnected(p));

        try {
            if (window.Clerk === undefined) return;
            if (window.Clerk.session === null) return;
            // setup signalR with token
            const token = await window.Clerk.session.getToken();
            if (token === undefined) {
                return;
            }

            this.checkSignalR(token);
        } catch (error) {
            logService.logError(`${_name}.mounted: ${error.message}`);
        }
    };

    componentWillUnmount = async () => {
        if (!this.mounted) return;
        this.mounted = false;

        if (this.onDataReceived) this.onDataReceived = this.onDataReceived();
        if (this.onReconnected) this.onReconnected = this.onReconnected();

        await authService.cleanup();
    };

    checkSignalR = async (token) => {
        if (authService.isConnected()) {
            return;
        }

        const r = await authService.initStreamer(token);
        if (r) return r;

        logService.logError(`${_name}.mounted: streamer not initialized`);
    };

    handleReconnected = async (p) => {
        try {
            const token = await window.Clerk.session.getToken();
            if (token === undefined) {
                return;
            }

            // send user id after reconnect
            const payload = messageFactory.createRequest('reconnectToken', token);
            const msg = messageFactory.serialize(payload);
            await systemStreamer.send(msg);
        } catch (error) {
            logService.logError(`${_name}.handleReconnected: ex=${error.message}`);
        }
    };

    handleData = (p) => {
        if (p.A === 'OnNotificationPublished') {
            const item = JSON.parse(p.D);
            // setTimeout(() => OpenToast('test'), 2000);
            // OpenToast(item.message);
            toast(item.message, { position: 'bottom-right', className: 'toast-message' });
            return;
        }

        if (p.A === 'OnJournalUpdated') {
            const items = JSON.parse(p.D);

            // send system event with same name different channel
            // YourDataTab should get this
            publisher.pubEvent('OnJournalUpdated', items);
        }

        if (p.A === 'OnQuotaUpdated') {
            const items = JSON.parse(p.D);

            // send system event with same name different channel
            // YourDataTab should get this
            publisher.pubEvent(events.onQuotaUpdated, items);
        }

        if (p.A === events.onQuotaDeleted) {
            const items = JSON.parse(p.D);

            // send system event with same name different channel
            // YourDataTab should get this
            publisher.pubEvent(events.onQuotaDeleted, items);
        }
    };

    render() {
        return <>{this.props.children}</>;
    }
}

export default PageContent;
